import {FC, useState, useEffect, HTMLProps} from 'react'
import {useIntl} from 'react-intl'

type Props = Omit<HTMLProps<HTMLInputElement>, 'onChange'> & {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  value?: string | number
}

function formatTime(value: string) {
  const numbers = value.replace(/\D/g, '')

  const minutes = numbers.slice(-2).padStart(2, '0')
  const rawHours = numbers.slice(0, -2)

  const hours = rawHours.replace(/^0+/, '') || '00'

  return `${hours}:${minutes}`
}


const InputHour: FC<Props> = ({onChange, value = '', ...props}) => {
  const [hourValue, setHourValue] = useState<string>(formatTime(value.toString()))

  useEffect(() => {
    setHourValue(formatTime(value.toString()))
  }, [value])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value.replace(/\D/g, '')
    const formatted = formatTime(rawValue)

    setHourValue(formatted)

    if (onChange) {
      onChange({
        ...event,
        target: {
          ...event.target,
          value: rawValue,
        },
      })
    }
  }

  return <input type='text' onChange={handleChange} value={hourValue} {...props} />
}

export {InputHour}
